import { MachineGroupScheduleTimeRange } from './calendar/machine-group-schedule-time-range';
import { Operator } from './operator';

export const OPERATOR_SHIFTS = ['N', 'M', 'T'];

export class OperatorCalendarEntry {
  constructor(
    public operatorHash?: string,
    public plannedShift?: string,
    public shift?: string,
    public available?: boolean,
    public startTime?: number,
    public endTime?: number,
    public exceptionType?: string,
  ) { }
}

export class OperatorCalendarShift {
  constructor(
    public shift?: string,
    public working?: boolean,
    public startTime?: number,
    public endTime?: number,
    public operators?: OperatorCalendarEntry[],
  ) { }
}

export class OperatorCalendarDay {
  constructor(
    public date?: number,
    public year?: number,
    public week?: number,
    public working?: boolean,
    public colors?: string[],
    public timeRanges?: MachineGroupScheduleTimeRange[],
    public shifts?: OperatorCalendarShift[],
    public unassignedOperators?: OperatorCalendarEntry[],
  ) { }
}

export class OperatorCalendar {
  constructor(
    public workingModelGroupHash?: string,
    public startDate?: number,
    public endDate?: number,
    public operators?: Operator[],
    public days?: OperatorCalendarDay[],
  ) { }
}

/** Valor de un operario en la ventana de un día, tal y como lo espera la API. */
export interface OperatorDayChange {
  operatorHash: string;
  type: string;
  shift?: string;
  startTime?: number;
  endTime?: number;
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/operator-calendar.ts